import { stripInlineMarkdown } from "@/utils/inline-markdown";

export type PhaseStatus = "done" | "active" | "pending";

export interface CyclePhase {
  id: string;
  label: string;
  status: PhaseStatus;
  duration: string;
}

export const cycleDemoData: CyclePhase[] = [
  { id: "discover", label: "Discover", status: "done", duration: "3d" },
  { id: "design", label: "Design", status: "done", duration: "5d" },
  { id: "build", label: "Build", status: "active", duration: "8d" },
  { id: "test", label: "Test", status: "pending", duration: "3d" },
  { id: "ship", label: "Ship", status: "pending", duration: "1d" },
  { id: "measure", label: "Measure", status: "pending", duration: "5d" },
];

export function cyclePhaseColor(status: PhaseStatus): string {
  switch (status) {
    case "done":
      return "var(--status-2)";
    case "active":
      return "var(--status-1)";
    case "pending":
      return "var(--subtle)";
  }
}

export interface CycleLegendItem {
  id: string;
  label: string;
  value: string;
  color: string;
  status: PhaseStatus;
}

export function phasesToLegendItems(phases: CyclePhase[]): CycleLegendItem[] {
  return phases.map((p) => ({
    id: p.id,
    label: stripInlineMarkdown(p.label),
    value: p.duration,
    color: cyclePhaseColor(p.status),
    status: p.status,
  }));
}
